import moment from 'moment'

export default (ctx) => {
  ctx.app.i18n.beforeLanguageSwitch = (oldLocale, newLocale) => {
    moment.locale(newLocale)
  }
}
